import { Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React from 'react'
import { Outlet } from 'react-router'

import Sidebar from '@/components/sidebar'

import { GALLERY_WIDTH } from '../utils/constants'

interface MainLayoutProps {}

const SidebarLayout: React.FC<MainLayoutProps> = () => {
  const theme = useTheme()

  return (
    <Box display="flex" flexGrow={1}>
      <Box
        display="flex"
        width={`${GALLERY_WIDTH}px`}
        bgcolor={theme.palette.background.paper}
      >
        <Sidebar />
      </Box>
      <Outlet />
    </Box>
  )
}

export default SidebarLayout
